import requests from "./httpService";

const SessionSettingsService = {
    getSessionSettings(companyId) {
        return requests.get(`/session-management/all?company_id=${companyId}`);
    },
    createSessionSetting(body) {
        return requests.post(`/session-management/create`, body);
    },
    updateSessionSetting(id, body) {
        return requests.post(`/session-management/update/${id}`, body);
    },
    updateStatus(id) {
        return requests.post(`/session-management/statusupdate/${id}`);
    },
    deleteSessionSetting(id, companyId) {
        return requests.delete(`/session-management/${id}`, { company_id: companyId });
    }
};

export default SessionSettingsService;
